import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { RECORD_INVOICE_TYPE } from "@/constants";
import { InputWithAlert } from "@/components/ui/input-with-alert";

export const OriginalInvoiceReferenceSection = ({ originalInvoice }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!originalInvoice) {
    return null;
  }

  const invoiceTypeName = RECORD_INVOICE_TYPE[originalInvoice.invoiceType]
    ? RECORD_INVOICE_TYPE[originalInvoice.invoiceType](t)
    : originalInvoice.invoiceType;

  return (
    <div className="w-full pb-6">
      <div className="text-xl font-medium pb-4">
        {t("invoices:original_invoice")}
      </div>

      <div className="w-full lg:w-8/12 grid grid-cols-2 gap-4">
        <div>
          <div className="relative">
            <InputWithAlert
              label={t("invoices:invoice_id")}
              value={originalInvoice.invoiceId}
              readOnly={true}
              disabled
              inputClassName={"h-12 mt-2 mb-4 bg-white"}
            />
            <div className="w-full flex justify-end absolute top-[45px] right-4">
              <Button
                variant="link"
                className="text-blueText p-0 h-auto"
                onClick={() =>
                  navigate(`/admin/invoices/details/${originalInvoice.id}`)
                }
              >
                {t("common:button_view")}
              </Button>
            </div>
          </div>
          <InputWithAlert
            label={t("invoices:date_of_creation")}
            value={originalInvoice.invoiceId}
            readOnly={true}
            disabled
            inputClassName={"h-12 mt-2 mb-4 bg-white"}
          />
          <InputWithAlert
            label={t("invoices:price_brutto")}
            value={`${parseFloat(originalInvoice.invoiceBrutto).toFixed(2)} ${originalInvoice.paymentCurrency}`}
            readOnly={true}
            disabled
            inputClassName={"h-12 mt-2 mb-4 bg-white"}
          />
        </div>
        <div>
          <InputWithAlert
            label={t("invoices:invoice_type")}
            value={invoiceTypeName}
            readOnly={true}
            disabled
            inputClassName={"h-12 mt-2 mb-4 bg-white"}
          />
          <InputWithAlert
            label={t("invoices:counterparty_info")}
            value= {originalInvoice.counterpartyName}
            readOnly={true}
            disabled
            inputClassName={"min-h-12 mt-2 mb-4 bg-white"}
          />
        </div>
      </div>
    </div>
  );
};
